export default (scroller) => {

  if(document.querySelector('.hidden-blocks__item')){

    let hiddenBlocksItems = document.querySelectorAll('.hidden-blocks__item');
    let documentsColumn = document.querySelectorAll('.documents__column');
  
    hiddenBlocksItems.forEach(item => {
      let itemTitle = item.querySelector('.hidden-blocks__title');

      itemTitle.addEventListener('click', () => {
        let thisItem = item;

        hiddenBlocksItems.forEach(item => {
          if (item.classList.contains("item-opened")  && (thisItem != item)) {
            item.classList.remove('item-opened');
          }
        });

        documentsColumn.forEach((documentsColumn) => {
          if (documentsColumn.classList.contains("documents-opened")) {
            documentsColumn.classList.toggle('documents-opened');
          }
        });

        
        thisItem.classList.toggle('item-opened');

        setTimeout(() => {
          scroller.scrollTo(itemTitle, {
            offset: -200, 
            easing: [0, 0, 0, 0], 
            duration: 100,
          });
        }, 250);

        setTimeout(() => {
          scroller.update();
        }, 300);

      });

    });
  }

}